// extracted by mini-css-extract-plugin
export default {"input":"DesiredLevel_input__keYQI","fillSkills":"DesiredLevel_fillSkills__IqRJi"};